// extracted by mini-css-extract-plugin
module.exports = {"activeBtn":"FavoritesFilter_activeBtn__1nIP8"};